import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import fr from "src/config/i18n/fr.json";
export default i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "fr",
    resources: {
      fr: {
        translation: fr,
      },
    },
    backend: {
      loadPath: "src/config/i18n/{{lng}}.json",
    },
  });
